module.exports = __webpack_public_path__ + "img/25_24.452f21d3.png";